import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SlogStatusGrid from "../AgGrid/slog-status";
import CommonLoader from "../Loaders/loader";

const LogData = ({ handleWeldNumberChange, setStartDate, setEndDate }) => {
  const history = useHistory();
  const reducer = useSelector((state) => state.slogReducer);
  const slogData = useSelector((state) => state.slogReducer.slogsList);

  const { t } = useTranslation();

  const loader = reducer?.isSlogsLoading;
  const filteredData = useSelector(
    (state) => state.slogReducer.filteredTableData
  );

  const dataSource = filteredData.map((item, index) => {
    const { weld_number, status, weld_time } = item;

    const originalItem = slogData?.find(
      (slog) => slog.weldNumber === weld_number
    );

    const allSlogTime = Array.isArray(originalItem?.slogs)
      ? originalItem.slogs.map((ite) => ite.time)
      : [];

    const startTimestamp =
      allSlogTime.length > 0 ? Math.min(...allSlogTime) : "-";

    return {
      key: index,
      sl_no: index + 1,
      weldNumber: weld_number,
      weldStartTime: startTimestamp,
      weld_time: weld_time || "-",
      status: status || "Unknown",
    };
  });

  const handleRowClick = (record) => {
    history.push(`/slog-weld/${record.weldNumber}`);
  };

  const handleDateFilterChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  return (
    <>
      {loader ? (
        <div className="slogdata-loader">
          <CommonLoader />
        </div>
      ) : (
        <div className="custom-table-wrapper">
          {filteredData.length > 0 ? (
            <>
              <SlogStatusGrid
                rows={dataSource}
                isLoading={loader}
                handleRowClick={handleRowClick}
                handleWeldNumberChange={handleWeldNumberChange}
                handleDateFilterChange={handleDateFilterChange}
              />
            </>
          ) : (
            <div className="slog-NoData">
              <p>{t("sLogData.weldlognotAvailable")}</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default LogData;
